export const css = {
    root: '_2A1GYYGU',
    title: '_2-EOM2L6',
    cards: '_1wQHU0PA',
    studyplan: '_38VB_J3D',
    ' _key': 'certwise-theme/certwise/explore-view/chooser'
};
export default css;
